import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Restaurant from '../../../app/data/models/restaurant';
import { RootState } from '../../../app/store/configureStore';

export interface BillerHomeState {
  restaurants: Restaurant[];
  restaurantsLoaded: boolean;
  status: 'idle' | 'pending' | 'succeeded' | 'failed';
}

const initialState: BillerHomeState = {
  restaurants: [],
  restaurantsLoaded: false,
  status: 'idle',
};

export const fetchBillerRestaurantListAsync = createAsyncThunk(
  'billerRestaurants/fetchList',
  async ({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) => {
    // Replace with your API call
    const response = await fetch(
      `/api/biller/restaurants?page=${pageNumber}&size=${pageSize}`
    );
    return (await response.json()) as Restaurant[];
  }
);

const billerHomeSlice = createSlice({
  name: 'billerRestaurants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillerRestaurantListAsync.fulfilled, (state, action) => {
        state.restaurants = action.payload;
        state.restaurantsLoaded = true;
        state.status = 'succeeded';
      })
      .addCase(fetchBillerRestaurantListAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchBillerRestaurantListAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const billerRestaurantsSelectors = {
  selectAll: (state: RootState) => state.billerRestaurants.restaurants,
};

export default billerHomeSlice.reducer;
